<template>
  <div class="pool__detail">
    <div class="pool__detail__header">
      <div class="pool__detail__header__cus" v-if="poolObj.cusName">
        <span class="detail__header__text">客户名称:</span>
        <span class="detail__header__com">{{poolObj.cusName}}</span>
      </div>
      <div class="pool__detail__header__info">
        <div class="detail__info__left">
          <span class="left__text">可分配金额(元):</span>
          <span class="left__num">{{ advancesAmt|filerthousandchar}}</span>
        </div>
        <div class="detail__info__left left__customer">
          <span class="left__text left__text__customer">机构名称:</span>
          <span class="left__num">{{poolObj.comBrName}}</span>
        </div>
      </div>
      <div class="pool__detail__header--tips" v-if="poolObj.cusName">
        <div class="tips--title">温馨提示</div>
        <div class="tips--info">
          提示：当且仅当客户提前还本，才需要在此页面确认回款本金，否则仅需保证客户实际到款即可，系统将根据借据还款计划自动扣款入账。
        </div>
      </div>
    </div>
    <div class="pool__detail--line"></div>
    <div class="pool__detail__content" v-if="poolObj">
      <div
        class="detail__item"
        v-for="item in poolObj.repaymentFlowDetailList"
        :key="item.billNo"
      >
        <div class="md-example-child md-example-child-detail-item md-example-child-detail-item-0">
          <md-field>
            <md-detail-item title="合同编号" :content="item.cnContNo" />
            <md-detail-item title="借据编号" :content="item.bankBillNo" />
            <md-detail-item title="借据金额(元)" :content="item.loanAmount|filerthousandchar" />
            <md-detail-item title="借据余额(元)" :content="item.loanBalance|filerthousandchar" />
            <md-detail-item title="本期应还日期" :content="item.psDueDt" />
            <md-detail-item title="本期应还本金(元)" :content="item.psPrcpAmt|filerthousandchar" />
            <md-detail-item title="本期应还利息(元)" :content="item.psNormIntAmt|filerthousandchar" />
            <div class="detail__item__ipt">
              <span>本次提前还本金额(元)</span>
              <input type="text" @input="handleToInput" @blur="handleToBlur($event,item.bankBillNo,item.billNo,item.loanBalance)" @focus="handleToFocus"
                     placeholder="本次提前还本金额" :ref="item.billNo">
            </div>
          </md-field>
        </div>
      </div>
    </div>
    <div class="pool__detail__content" v-else>
      <van-empty description="暂无数据" />
    </div>
    <div class="pool__detail__footer">
      <div class="pool__footer__back" @click="handleToSureBack">
        <span>确认</span>
      </div>
      <div class="pool__footer__back" @click="handleToBack">
        <span>返回</span>
      </div>
    </div>
    <div class="pool__detail__float" v-if="floadFlag">
      <div class="float__content" v-if="list.length>0">
        <div class="item">
          <span>本次提前还本金额:</span>
        </div>
        <div class="item" v-for="(item,index) in list" :key="index">
          <span>借据编号: {{item.bankBillNo}};</span>
          <span>还本(元): {{item.value}}</span>
        </div>
        <div class="btn">
          <button class="btn-sure" @click="handleToCustomer(1)">确认</button>
          <button class="btn-cancle" @click="handleToCustomer(0)">取消</button>
        </div>
      </div>
      <div class="float__content" v-else>
        <div class="item" >
          <span>请至少填入一项借据的还款本金！</span>
        </div>
        <div class="btn">
          <button @click="handleToCustomer(0)">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">

import { DetailItem, Field } from 'mand-mobile'
import { get, postjson } from '@/api/api'
import { addthousandchar } from '@/tools/common'
import recordPageTime from '@/mixin/minin'

export default {
  name: 'QueryXDList',
  components: {
    [Field.name]: Field,
    [DetailItem.name]: DetailItem
  },
  data () {
    return {
      poolObj: '',
      floadFlag: false,
      ToastFlag: true,
      list: [],
      advancesAmt: '',
      oldadvancesAmt: '',
      loginid: ''
    }
  },
  beforeMount () {
    this.getAccountDetail()
  },
  methods: {
    // 获取初始数据
    async getAccountDetail () {
      this.loginid = this.$route.params.loginid
      const result = await get('/api/CBMS-APP/virAccount/findVirAccountDetail', this.$route.params)
      this.poolObj = result.data
      this.advancesAmt = Number(result.data.advancesAmt)
      this.oldadvancesAmt = Number(result.data.advancesAmt)
    },
    // 确认回款数据处理
    async handleToSureBack () {
      if (this.ToastFlag) {
        document.body.style.overflow = 'hidden'
        this.floadFlag = true
        const poolObjList = this.poolObj.repaymentFlowDetailList
        poolObjList.forEach((item, index, arr) => {
          this.list.forEach((listItem, listIndex, listArr) => {
            if (item.bankBillNo === listItem.bankBillNo) {
              arr[index].receivedPrincipal = listItem.value
            }
          })
        })
        this.poolObj.repaymentFlowDetailList = poolObjList
      }
    },
    // input失去焦点触发
    handleToBlur (e, bankBillNo, billNo, loanBalance) {
      const iptValue = e.target.value ? e.target.value : 0
      if ((this.advancesAmt - Number(iptValue)) >= 0 && Number(iptValue) <= loanBalance) {
        this.advancesAmt = this.advancesAmt - Number(iptValue)
        this.list = this.list.filter(item => item.bankBillNo !== bankBillNo)
        if (iptValue !== 0) {
          this.list.push({ bankBillNo, billNo, value: iptValue })
        }
      } else {
        this.ToastFlag = false
        e.target.value = ''
        this.$toast.success({
          message: '不能大于可分配金额或贷款余额',
          onClose: () => {
            this.ToastFlag = true
          }
        })
        return false
      }
    },
    // input获取焦点触发
    handleToFocus (e) {
      const iptValue = e.target.value ? Number(e.target.value) : 0
      this.advancesAmt = this.advancesAmt + iptValue
      e.target.value = ''
    },
    // input value变化触发
    handleToInput (e) {
      const iptValue = e.target.value ? e.target.value : 0
      const iptReg = /^\d+(\.\d+)?$/
      const iptFlag = iptReg.test(iptValue)
      if (!iptFlag) {
        this.$toast.success('输入内容包含非数字')
        e.target.value = ''
        return false
      }
    },
    async handleToCustomer (val) {
      if (val === 1) {
        this.floadFlag = false
        document.body.style.overflow = 'auto'
        console.log(this.poolObj)
        const result = await postjson('/api/CBMS-APP/virAccount/saveRepaymentFlowDetail', this.poolObj)
        if (result.success) {
          this.$toast.success({
            message: '已完成',
            onClose: () => {
              // this.$router.push('/custompool')
              // this.$router.replace('/custompool')
              window.location.href = 'emobile:{"func":"closeClick"}'
            }
          })
        } else {
          this.$toast.fail('系统错误，请联系管理员')
        }
      } else if (val === 0) {
        this.floadFlag = false
        document.body.style.overflow = 'auto'
      } else if (val === 2) {
        this.floadFlag = false
        document.body.style.overflow = 'auto'
        window.location.href = 'emobile:{"func":"closeClick"}'
      }
    },
    handleToBack () {
      this.$router.push({ name: 'queryIndex', params: { loginid: this.loginid } })
    }

  },
  filters: {
    filerthousandchar (num) {
      return addthousandchar(num.toString())
    }
  },
  mixins: [recordPageTime]
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.pool__detail
  position : relative
  min-height : 100vh
  overflow-y : scroll
  .pool__detail__header
    position : fixed
    left : 0
    top: 0
    width : 100%
    z-index : 10
    .pool__detail__header__cus
      display : flex
      padding : 16px 0 8px 0
      background-color : #687591
      //border-bottom : 1px solid #999999
      .detail__header__text
        width : 140px
        padding-left : 16px
        font-size : 32px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        color : #ffffff
      .detail__header__com
        flex : 1
        font-size : 32px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        color : #ffffff
    .pool__detail__header__info
      display : flex
      padding : 8px 0 16px 0
      background-color : #687591
      justify-content : center
      align-items : center
      .detail__info__left
        flex : 1
        padding-left : 16px
        font-size : 24px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        color : #ffffff
    .pool__detail__header--tips
      padding : 16px 16px 16px 16px
      background-color : #f7f7f7
      line-height : 1.5
      .tips--title
        font-size : 32px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
      .tips--info
        text-indent : 32px
        font-size : 28px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
  .pool__detail__content
    padding : 0 16px 96px 16px
    .detail__item
      padding : 0 16px 16px 16px
      margin-bottom : 16px
      border : 1px solid #999999
      border-radius : 12px
      .detail__item__header
        margin-top : 16px
        span
          font-size : 24px
          font-family: MyriadPro-Regular
          font-weight: normal
          font-stretch: normal
        .detail__item__com
          margin-right : 16px
      .detail__item__info
        margin-top : 16px
        display : flex
        .detail__item__left
          flex : 1
          span
            font-size : 24px
            font-family: MyriadPro-Regular
            font-weight: normal
            font-stretch: normal
          .left__item__text
            padding-right : 16px
      .detail__item__ipt
        display : flex
        justify-content : space-between
        margin-top : 16px
        font-size : 28.5px
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        span
          width : 180px
          margin-right : 32px
          color :#858b9c
        input
          width : 240px
          padding : 16px
          outline : none
          border : 1px solid #999999
          border-radius : 8px
  .pool__detail--line
    width : 100%
    height : 340px
  .pool__detail__footer
    display : flex
    position : fixed
    left:0
    bottom :0
    width : 100vw
    padding : 16px 0
    background : #687591
    .pool__footer__back
      flex : 1
      text-align : center
      border-right : 1px solid #ffffff
      span
        display : inline-block
        padding : 16px
        color : #ffffff
        font-size : 32px
    .pool__footer__add
      border-left : 1px solid #ffffff
      flex : 1
      text-align : center
      a
        display : inline-block
        padding : 16px
        color : #ffffff
        font-size : 32px
  .pool__detail__float
    position : absolute
    top:0
    left : 0
    right : 0
    bottom : 0
    background-color:rgba(0,0,0,0.5)
    z-index:100
    .float__content
      width : 85%
      position : fixed
      top:50%
      left : 50%
      transform : translate(-50%,-50%)
      box-shadow: 0 5px 10px rgba(0,0,0,0.5);
      background-color: #f1f1f1;
      border-radius : 12px
      .item
        text-align : left
        font-size : 32px
        padding : 16px
      .btn
        display : flex
        margin-top : 16px
        text-align : center
        button
          flex : 1
          display : inline-block
          width : 100%
          padding : 16px
          font-size : 32px
          color : #ffffff
          background : #0088f6
          outline : none
          border : none
        .btn-sure
          border-right : 1px solid #ffffff
        .btn-cancle
          border-left : 1px solid #ffffff
</style>
